<div class="product-sorting js-sort-selection" [class.side-nav]="sidenav === 'true'">
  <div class="label">
    {{ 'product.productSorting.sortBy' | cxTranslate }}
  </div>
  <ng-select
    [searchable]="false"
    [clearable]="false"
    dropdownPosition="bottom"
    placeholder="{{ placeholder }}"
    (change)="sortList($event)"
    [ngModel]="selectedOption"
  >
    @for (sort of sortOptions; track sort) { @if (!((showSrp || basepriceHidden) && (this.basePriceAsc === sort.code ||
    this.basePriceDes === sort.code))) {
    <ng-option [value]="sort.code">{{ sort.name ? sort.name : sortLabels ? sortLabels[sort.code] : '' }}</ng-option>
    } }
  </ng-select>
</div>
